import script from "./NewGamePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewGamePage.vue?vue&type=script&setup=true&lang=ts"

import "./NewGamePage.vue?vue&type=style&index=0&id=75db193a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75db193a"]])

export default __exports__